/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const goodLuckCoreEntitiesGameRoleEnum = {
  Top: "Top",
  Jungle: "Jungle",
  Mid: "Mid",
  Adc: "Adc",
  Support: "Support",
} as const;

export type GoodLuckCoreEntitiesGameRoleEnumKey =
  (typeof goodLuckCoreEntitiesGameRoleEnum)[keyof typeof goodLuckCoreEntitiesGameRoleEnum];

export type GoodLuckCoreEntitiesGameRole = GoodLuckCoreEntitiesGameRoleEnumKey;
